// extracted by mini-css-extract-plugin
export default {"rules":"ChangePasswordForm_rules__X8IE+","submit-button":"ChangePasswordForm_submit-button__f6YGI"};